/** Orden y metadatos visuales de servicios partner (sección + modal). */
export const PARTNER_SERVICE_ORDER = [
  'marketplace',
  'platform',
  'reports',
  'featured',
  'lead',
  'advertising',
  'affiliate',
  'manager',
  'advisory',
]

export const PARTNER_SERVICE_STYLES = {
  marketplace: {
    badgeKey: true,
    badgeClassLight: 'bg-teal-100 text-teal-700',
    badgeClassDark: 'bg-teal-500/20 text-teal-300',
    iconPath:
      'M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4',
    iconBg: 'bg-teal-100',
    iconColor: 'text-teal-600',
    iconBgDark: 'bg-teal-500/20',
    iconColorDark: 'text-teal-400',
  },
  platform: {
    badgeKey: true,
    badgeClassLight: 'bg-indigo-100 text-indigo-700',
    badgeClassDark: 'bg-indigo-500/20 text-indigo-300',
    iconPath:
      'M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z',
    iconBg: 'bg-violet-100',
    iconColor: 'text-violet-600',
    iconBgDark: 'bg-violet-500/20',
    iconColorDark: 'text-violet-400',
  },
  reports: {
    badgeKey: true,
    badgeClassLight: 'bg-emerald-100 text-emerald-700',
    badgeClassDark: 'bg-amber-400/20 text-amber-300 border border-amber-400/30',
    iconPath:
      'M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z',
    iconBg: 'bg-emerald-100',
    iconColor: 'text-emerald-600',
    iconBgDark: 'bg-emerald-500/20',
    iconColorDark: 'text-emerald-400',
  },
  featured: {
    badgeKey: true,
    badgeClassLight: 'bg-amber-100 text-amber-700',
    badgeClassDark: 'bg-amber-500/20 text-amber-300',
    iconPath:
      'M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z',
    iconBg: 'bg-amber-100',
    iconColor: 'text-amber-600',
    iconBgDark: 'bg-amber-500/20',
    iconColorDark: 'text-amber-400',
  },
  lead: {
    badgeKey: false,
    badgeClassLight: '',
    badgeClassDark: '',
    iconPath:
      'M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0z',
    iconBg: 'bg-indigo-100',
    iconColor: 'text-indigo-600',
    iconBgDark: 'bg-indigo-500/20',
    iconColorDark: 'text-indigo-400',
  },
  advertising: {
    badgeKey: false,
    badgeClassLight: '',
    badgeClassDark: '',
    iconPath:
      'M11 5.882V19.24a1.76 1.76 0 01-3.417.592l-2.147-6.15M18 13a3 3 0 100-6M5.436 13.683A4.001 4.001 0 017 6h1.832c4.1 0 7.625-1.234 9.168-3v14c-1.543-1.766-5.067-3-9.168-3H7a3.988 3.988 0 01-1.564-.317z',
    iconBg: 'bg-purple-100',
    iconColor: 'text-purple-600',
    iconBgDark: 'bg-purple-500/20',
    iconColorDark: 'text-purple-400',
  },
  affiliate: {
    badgeKey: false,
    badgeClassLight: '',
    badgeClassDark: '',
    iconPath:
      'M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1',
    iconBg: 'bg-pink-100',
    iconColor: 'text-pink-600',
    iconBgDark: 'bg-pink-500/20',
    iconColorDark: 'text-pink-400',
  },
  manager: {
    badgeKey: false,
    badgeClassLight: '',
    badgeClassDark: '',
    iconPath:
      'M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6',
    iconBg: 'bg-teal-100',
    iconColor: 'text-teal-600',
    iconBgDark: 'bg-teal-500/20',
    iconColorDark: 'text-teal-400',
  },
  advisory: {
    badgeKey: true,
    badgeClassLight: 'bg-sky-100 text-sky-700',
    badgeClassDark: 'bg-sky-400/20 text-sky-300',
    iconPath:
      'M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z',
    iconBg: 'bg-sky-100',
    iconColor: 'text-sky-600',
    iconBgDark: 'bg-sky-500/20',
    iconColorDark: 'text-sky-400',
  },
}

export function getPartnerServiceStyle(key) {
  return PARTNER_SERVICE_STYLES[key] || PARTNER_SERVICE_STYLES.marketplace
}
